var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnRediscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.23977C13.8166 5.91993 13.2043 4.69701 12.2575 3.75939C11.3107 2.82177 10.0818 2.22146 8.76025 2.05093C7.43869 1.88041 6.09772 2.14913 4.9439 2.8157C3.79009 3.48228 2.88744 4.50972 2.375 5.73977M2 2.73977V5.73977H5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.73926C2.18342 10.0591 2.7957 11.282 3.74252 12.2196C4.68934 13.1573 5.91818 13.7576 7.23975 13.9281C8.56131 14.0986 9.90228 13.8299 11.0561 13.1633C12.2099 12.4968 13.1126 11.4693 13.625 10.2393M14 13.2393V10.2393H11",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnRediscover);
export default __webpack_public_path__ + "static/media/icn_btn_rediscover.ce02f902a47dd49390e331d10e1e228f.svg";
export { ForwardRef as ReactComponent };